import stylesheet from './icon.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import {getIconStyles} from "../../util/lazy";

export class NXTIcon extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
        void this.appendStyleLazy(getIconStyles);
    }

    get icon(): string {
        return this.getAttribute('icon');
    }

    render() {
        const element = document.createElement('div');
        element.classList.add('icon', `icon-${this.icon}`);
        return element;
    }

}

customElements.define('nxt-icon', NXTIcon);
